<template>
  <SubHeading :home="home" :tabs="tabs" :shorts="false" :currTab="currTab" @active="handleActive" />

  <!-- breadcrumbs -->
  <nav class="sba-collection-breadcrumb z-depth-0">
    <div class="container nav-wrapper">
      <div class="sba-collection-breadcrumb-row">
        <router-link to="/" class="breadcrumb sba-collection-crumb teal-text">
          <i class="material-icons">home</i>
          <span>Dashboard</span>
        </router-link>
        <i class="material-icons sba-collection-crumb-separator">chevron_right</i>
        <span class="breadcrumb sba-collection-crumb blue-grey-text pointable">
          <span>Schemes Home</span>
        </span>
        <span class="sba-collection-context">Scheme Enrollee Uploads</span>
      </div>
    </div>
  </nav>

  <div id="view"></div>

  <!-- Loader -->
  <div class="container progress" v-if="isLoading && isReady">
    <div class="indeterminate"></div>
  </div>

  <div class="sba-collection-page-surface is-workbench public-page-surface">
  <div class="container">
    <!-- Clients -->
    <LoadingDiv v-if="!isReady" />

    <div v-else>
      <div class="section public-client-surface sba-slide-in sba-slide-in-children">
        <div class="public-review-head">
          <div class="public-title-block">
            <label class="active teal-text">Schemes</label>
            <h5>Scheme Client Register</h5>
            <p>Open a scheme to upload enrollee lists and review the principal count already attached to it.</p>
          </div>
          <span class="public-info-pill">
            <i class="material-icons">upload_file</i>
            Upload lists by scheme
          </span>
        </div>

        <div class="public-search-card">
          <form>
            <div class="input-field">
              <input id="search" type="search" v-model="searchItem" placeholder="Search schemes by name">
              <label class="label-icon" for="search"><i class="material-icons">search</i></label>
              <i class="material-icons" @click="handleClearSearch" v-if="searchItem">clear</i>
            </div>
          </form>
        </div>

        <div class="public-search-status" v-if="searchItem">
          <div>
            <span>Search active</span>
            <strong>{{ searchItem }}</strong>
          </div>
          <button type="button" @click="handleClearSearch" title="clear search">
            <i class="material-icons">close</i>
          </button>
        </div>

        <div class="card z-depth-0 public-client-card" v-for="client in clients" :key="client.id">
          <div class="card-content">
            <div class="public-card-row">
              <div class="public-card-main">
                <span class="public-count-pill">
                  {{
                    `${client.principals_count
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                  }}
                  principals
                </span>
                <h5>
                  <router-link :to="{ name: 'publicAdd', params: { id: client.id } }">
                    {{ client.name }}
                  </router-link>
                </h5>
                <p>{{ client.phone }}, {{ client?.email }}</p>
              </div>

              <router-link
                :to="{ name: 'publicAdd', params: { id: client.id } }"
                class="public-card-action"
                title="Upload enrollee list"
              >
                <span>Upload List</span>
                <i class="material-icons">chevron_right</i>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="section center public-empty-state" v-if="!clients.length">
        <h6>No scheme <em>found</em>...</h6>
      </div>

      <PaginationDiv :payLoad="allPages" @newPage="handlePage" v-else />
    </div>
  </div>
  </div>
</template>

<script>
import { onMounted, ref, computed, watchEffect } from "vue";
import useModuleNavigation from "@/composables/useModuleNavigation";
import getItems from "@/composables/getItems";
import SubHeading from "@/components/HeaderSubDiv.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import PaginationDiv from "@/components/pager/PaginationDiv.vue";

export default {
  name: "publicClientHome",
  components: { SubHeading, LoadingDiv, PaginationDiv },
  setup() {
    const cat = ref("schemes");
    const response = ref(null);
    const isReady = ref(false);
    const isLoading = ref(true);
    const error = ref(null);
    const currUrl = ref(null);
    const currHook = ref(null);
    const searchItem = ref(null);
    const home = ref(null);
    const currTab = ref(null);
    const tabs = ref([]);

    const { routeToTab } = useModuleNavigation();

    // start
    onMounted(() => {
      // page name
      document.title = "All Clients";
    });

    // menu
    onMounted(() => {
      // load tab
      tabs.value.push({ id: 1, name: "Schemes", title: "All", icon: null, url: "public", hash: null, });
      tabs.value.push({ id: 2, name: "Schemes", title: "Upload List", icon: "upload", url: "public", hash: "#view"});

      // set default
      currTab.value = tabs.value.find(x => x.id === 1);
       // set home
      home.value = tabs.value.find(x => x.id === 1);
    });

    // handle curr status
    const handleActive = (tab) => {
      routeToTab(tab, { replace: tab?.url === "public" && !tab?.hash });
    };

    // numbering
    const numberBadge = (num) => {
      return (
        (allPages.value.current_page - 1) * allPages.value.per_page + num + 1
      );
    };

    // get function
    const getSearchItemsFromApi = (table) => {
      (async () => {
        const { res, err } = await getItems(table);

        if (res.value) {
          response.value = res.value.data;
        } else {
          error.value = err.value;
        }

        // page is ready, loading is complete
        isReady.value = true;
        isLoading.value = false;
      })();
    };

    // starter
    onMounted(() => {
      // set current Url
      currUrl.value = `client/list/search?c=${cat.value}`;
      // set current Hook
      currHook.value = "&";
      // get searchItem items from function
      getSearchItemsFromApi(currUrl.value);
    });

    // restart
    const handleClearSearch = () => {
      // start laoding
      isLoading.value = true;
      // null search
      searchItem.value = null;
      // set current Url
      currUrl.value = `client/list/search?c=${cat.value}`;
      // set current Hook
      currHook.value = "&";
      // get searchItem items from function
      getSearchItemsFromApi(currUrl.value);
    };

    // switch page
    const handlePage = (page) => {
      // start laoding
      isLoading.value = true;
      // get new page items from function
      getSearchItemsFromApi(`${currUrl.value}${currHook.value}page=${page}`); //
    };

    // search watcher
    watchEffect(() => {
      if (searchItem.value) {
        // start laoding
        isLoading.value = true;
        // set current Url
        currUrl.value = `client/list/search?c=${cat.value}&q=${searchItem.value}`;
        // set current Hook
        currHook.value = "&";
        // get searchItem items from function
        getSearchItemsFromApi(currUrl.value);
      } else {
        handleClearSearch();
      }
    });

    // output results
    const clients = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value.data;
      }
    });

    // output pages
    const allPages = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value; // get all
      }
    });

    return {
      handleActive,
      currTab,
      tabs,
      cat,
      handleClearSearch,
      handlePage,
      numberBadge,
      isReady,
      isLoading,
      error,
      home,
      searchItem,
      clients,
      allPages,
    };
  },
};
</script>

<style scoped>
.public-page-surface {
  min-height: calc(100vh - 260px);
  padding-bottom: 56px;
}

.public-client-surface {
  margin-top: -14px;
  padding-top: 0;
  position: relative;
  z-index: 1;
}

.public-review-head {
  align-items: flex-end;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 12px 20px -18px rgba(38, 50, 56, 0.55);
  display: flex;
  gap: 22px;
  justify-content: space-between;
  overflow: visible;
  padding: 24px 26px;
  position: relative;
  z-index: 2;
}

.public-review-head::before {
  border: 1px solid #c4d3d9;
  border-bottom: 0;
  border-radius: 7px 7px 0 0;
  content: "";
  height: 18px;
  left: -1px;
  pointer-events: none;
  position: absolute;
  right: -1px;
  top: -1px;
  z-index: 1;
}

.public-review-head > * {
  position: relative;
  z-index: 2;
}

.public-title-block h5 {
  color: #263238;
  font-weight: 700;
  margin: 4px 0 0;
}

.public-title-block p {
  color: #607d8b;
  line-height: 1.45;
  margin: 6px 0 0;
  max-width: 720px;
}

.public-info-pill {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cfd8dc;
  border-radius: 999px;
  color: #263238;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.82rem;
  font-weight: 700;
  gap: 8px;
  min-height: 40px;
  padding: 0 14px;
}

.public-info-pill i {
  color: #00897b;
  font-size: 19px;
}

.public-search-card {
  background: #f7f7f7;
  border: 1px solid #c4d3d9;
  border-radius: 0 0 6px 6px;
  border-top: 0;
  box-shadow: 0 14px 26px -24px rgba(38, 50, 56, 0.74);
  margin-bottom: 16px;
  padding: 12px 16px;
}

.public-search-card:has(+ .public-search-status) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  box-shadow: none;
  margin-bottom: 0;
}

.public-search-card form,
.public-search-card .input-field {
  margin: 0;
}

.public-search-card .input-field {
  position: relative;
}

.public-search-card input[type="search"] {
  background: #ffffff;
  border-bottom: none !important;
  border-radius: 6px;
  box-sizing: border-box;
  box-shadow: none !important;
  color: #263238;
  font-weight: 600;
  height: 48px;
  line-height: 48px;
  margin: 0;
  padding-left: 46px;
  padding-right: 42px;
  width: 100%;
}

.public-search-card .label-icon {
  align-items: center;
  display: flex;
  height: 48px;
  left: 10px;
  line-height: 48px;
  position: absolute;
  top: 0;
}

.public-search-card .material-icons {
  color: #00897b;
  height: 48px;
  line-height: 48px;
}

.public-search-card .input-field > i {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 48px;
  line-height: 48px;
  position: absolute;
  right: 10px;
  top: 0;
}

.public-search-status {
  align-items: center;
  background: #ffffff;
  border: 1px solid #c4d3d9;
  border-radius: 0 0 6px 6px;
  border-top: 0;
  box-shadow: 0 16px 28px -24px rgba(38, 50, 56, 0.72);
  color: #263238;
  display: flex;
  justify-content: space-between;
  margin: 0 0 16px;
  padding: 12px 14px 12px 16px;
}

.public-search-status span {
  color: #607d8b;
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 5px;
  text-transform: uppercase;
}

.public-search-status strong {
  color: #263238;
  font-size: 0.98rem;
}

.public-search-status button {
  align-items: center;
  background: #f7f7f7;
  border: 1px solid #e1e8eb;
  border-radius: 50%;
  color: #455a64;
  cursor: pointer;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  padding: 0;
  width: 32px;
}

.public-search-status button i {
  font-size: 18px;
}

.public-client-card {
  background: linear-gradient(180deg, #ffffff 0%, #fdfdfd 100%);
  border: 1px solid #c4d3d9;
  border-radius: 6px;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9), 0 18px 32px -30px rgba(38, 50, 56, 0.72) !important;
}

.public-client-card .card-content {
  background: transparent;
}

.public-card-row {
  align-items: center;
  display: flex;
  gap: 24px;
  justify-content: space-between;
}

.public-card-main {
  min-width: 0;
}

.public-count-pill {
  background: #e8f3f2;
  border: 1px solid #9bd2cb;
  border-radius: 999px;
  color: #00695c;
  display: inline-flex;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1;
  margin-bottom: 8px;
  padding: 8px 11px;
}

.public-card-main h5 {
  color: #263238;
  font-weight: 700;
  margin: 0;
}

.public-card-main h5 a {
  color: #263238;
}

.public-card-main p {
  color: #607d8b;
  margin: 7px 0 0;
}

.public-card-action {
  align-items: center;
  background: #ffffff;
  border: 1px solid #cfd8dc;
  border-radius: 999px;
  color: #263238;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.78rem;
  font-weight: 800;
  gap: 8px;
  min-height: 38px;
  padding: 0 9px 0 14px;
  text-transform: uppercase;
}

.public-card-action i {
  color: #00897b;
  font-size: 19px;
}

.public-empty-state {
  color: #607d8b;
}

.progress {
  margin-top: 0;
}

@media only screen and (max-width: 992px) {
  .public-review-head,
  .public-card-row {
    align-items: flex-start;
    flex-direction: column;
  }
}

@media only screen and (max-width: 600px) {
  .public-review-head {
    gap: 14px;
    padding: 20px;
  }

  .public-title-block h5 {
    font-size: 1.35rem;
    line-height: 1.25;
  }

  .public-title-block p {
    font-size: 0.95rem;
  }

  .public-info-pill,
  .public-card-action {
    justify-content: center;
    width: 100%;
  }

  .public-search-card {
    padding: 10px;
  }

  .public-search-status {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }

  .public-search-status button {
    border-radius: 6px;
    width: 100%;
  }

  .public-client-card .card-content {
    padding: 18px;
  }

  .public-card-row {
    gap: 16px;
  }

  .public-card-main h5 {
    font-size: 1.18rem;
    line-height: 1.25;
  }
}
</style>
